import Vue from "vue";

export async function getReservasCalendario(
  context,
  [access_token, from, until, loading]
) {
  try {
    if (access_token) {
      if (loading) {
        context.commit("setLoading", true, { root: true });
      }
      const response = await Vue.axios({
        method: "GET",
        url: "/reservas_calendario",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        params: {
          from,
          until,
        },
      });
      context.commit("reservas/setReservasCalendario", response.data, {
        root: true,
      });
    }
  } catch (e) {
  } finally {
    context.commit("setLoading", false, { root: true });
  }
}

export async function getReservas(context, [access_token, params, loading]) {
  try {
    if (access_token) {
      if (loading) {
        context.commit("setLoading", true, { root: true });
      }
      const response = await Vue.axios({
        method: "GET",
        url: "/getReservas",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        params: params,
      });
      context.commit("reservas/setReservas", response.data.data, {
        root: true,
      });
      context.commit('reservas/setTotalReservas', response.data.meta.total, { root: true })
    }
  } catch (e) {
    context.commit("reservas/setReservas", [], {
      root: true,
    });
  } finally {
    context.commit("setLoading", false, { root: true });
  }
}


export async function getPresupuestos(context, [access_token, params, loading]) {
  try {
    if (access_token) {
      if (loading) {
        context.commit("setLoading", true, { root: true });
      }
      const response = await Vue.axios({
        method: "GET",
        url: "/getPresupuestos",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        params: params,
      });
      context.commit("reservas/setReservas", response.data.data, {
        root: true,
      });
      context.commit('reservas/setTotalReservas', response.data.meta.total, { root: true })
    }
  } catch (error) {
    console.error('Error al obtener los presupuestos:', error);
    context.commit("reservas/setReservas", [], {
      root: true,
    });
  } finally {
    context.commit("setLoading", false, { root: true });
  }
}

export async function getPresupuestosByTarjetas(context, [access_token, params, loading]) {
  try {
    if (access_token) {
      if (loading) {
        context.commit("setLoading", true, { root: true });
      }
      const response = await Vue.axios({
        method: "GET",
        url: "/getPresupuestosByTarjetas",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        params: params,
      });
      context.commit("reservas/setReservas", response.data.data, {
        root: true,
      });
      context.commit('reservas/setTotalReservas', response.data.meta.total, { root: true })
    }
  } catch (error) {
    console.error('Error al obtener los presupuestos:', error);
    context.commit("reservas/setReservas", [], {
      root: true,
    });
  } finally {
    context.commit("setLoading", false, { root: true });
  }
}

export async function generarTarjetasFromListado(context, [access_token, params, loading]) {
  try {
    if (access_token) {
      if (loading) {
        context.commit("setLoading", true, { root: true });
      }
      const response = await Vue.axios({
        method: "GET",
        url: "/generarTarjetasFromListado",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        params: params,
      });
      if (response.status == 200 && response.data?.pdf_url) {
        return response.data.pdf_url;
      } else {
        return null;
      }
    }
  } catch (error) {
    console.error('Error al generar las tarjetas:', error);
    return null;
  } finally {
    context.commit("setLoading", false, { root: true });
  }
}


export async function getReserva(context, [access_token, id]) {
  try {
    if (access_token) {
      const response = await Vue.axios({
        method: "GET",
        url: "/reservas/" + id,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
      });
      if (
        response &&
        response.status == 200 &&
        response.data &&
        response.data.data
      ) {
        return response.data.data;
      } else {
        return null;
      }
    }
  } catch (e) {
    return null;
  } finally {
  }
}

export async function getReservaByHash(context, [hash]) {
  try {
    const response = await Vue.axios({
      method: "GET",
      url: "/getReservaByHash?hash=" + hash,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    if (
      response &&
      response.status == 200 &&
      response.data &&
      response.data.data  
    ) {
      return response.data.data;
    } else {
      return null;
    }

  } catch (e) {
  } finally {
    context.commit("setLoading", false, { root: true });
  }
}

export async function crearReserva(context, [access_token, modelReserva]) {
  try {
    if (access_token) {
      const payload = {
        fecha_inicio: modelReserva.fecha_inicio,
        fecha_llegada: modelReserva.fecha_llegada,
        camino_id: modelReserva.camino.id,
        cliente_id: modelReserva.cliente.id,
        nombre: modelReserva.cliente.nombre,
        apellidos: modelReserva.cliente.apellidos,
        email: modelReserva.cliente.email,
        telefono: modelReserva.cliente.telefono,
        documento: modelReserva.cliente.documento,
        direccion: modelReserva.cliente.direccion,
        clientecomentarios: modelReserva.cliente.comentarios,
        tipo_cliente: modelReserva.cliente.tipoCliente,
        cant_peregrinos: modelReserva.cant_peregrinos,
        cant_habitaciones_individuales: modelReserva.cant_habitaciones_individuales,
        cant_habitaciones_dobles: modelReserva.cant_habitaciones_dobles,
        cant_habitaciones_dobles_matrimoniales: modelReserva.cant_habitaciones_dobles_matrimoniales,
        cant_habitaciones_triples: modelReserva.cant_habitaciones_triples,
        cant_habitaciones_cuadruples: modelReserva.cant_habitaciones_cuadruples,
        comentarios: modelReserva.comentarios,
        origen_id: modelReserva.origen.id,
        codigo_agencia: modelReserva.codigo_agencia,
        importe_reserva: modelReserva.importe_reserva,
        importe_presupuestado: modelReserva.importe_presupuestado,
        descripcion_importe_reserva: modelReserva.descripcion_importe_reserva,
        language: modelReserva.language,
      };

      if (modelReserva.estado_id) {
        payload.estado_id = modelReserva.estado_id;
      }

      const response = await Vue.axios({
        method: "POST",
        url: "/reservas",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        data: payload,
      });
      if (
        response &&
        response.status == 201 &&
        response.data &&
        response.data.data
      ) {
        return response.data.data;
      }
      // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
    }
  } catch (e) {
  } finally {
    // context.commit('setLoading', false, { root: true })
  }
}


export async function envioPresupuesto(context, [access_token, reserva_id]) {
  try {
    if (access_token) {
      const response = await Vue.axios({
        method: "POST",
        url: "/enviopresupuesto",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        data: {
          reserva_id,
        },
      });
      if (
        response &&
        response.status == 200 &&
        response.data &&
        response.data.data
      ) {
        context.commit('reservas/actUpdateListReservas', response.data.data, { root: true })
        return response.data.data;
      }

    }
  } catch (e) {
  } finally {
    // context.commit('setLoading', false, { root: true })
  }
}

export async function updateReserva(context, [access_token, modelReserva]) {
  try {
    modelReserva.origen_id = modelReserva.origen ? modelReserva.origen.id : null;
    if (access_token) {
      const response = await Vue.axios({
        method: "PUT",
        url: "/reservas/" + modelReserva.id,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        data: modelReserva
      });

      if (response.status == 200) {
        context.commit('reservas/actUpdateListReservas', response.data.data, { root: true })
        return response.data.data;
      }

      // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
    }
  } catch (e) {
  } finally {
    // context.commit('setLoading', false, { root: true })
  }
}

export async function asignarNumeroFactura(
  context,
  [access_token, reserva_id]
) {
  try {
    if (access_token) {
      const response = await Vue.axios({
        method: "POST",
        url: "/asignar_numero_factura",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        data: {
          reserva_id,
        },
      });
      if (response && response.status == 201 && response.data) {
        return response.data.factura;
      }
      // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
    }
  } catch (e) {
  } finally {
    // context.commit('setLoading', false, { root: true })
  }
}

export async function eliminarReserva(context, [access_token, reserva_id]) {
  try {
    if (access_token) {
      const response = await Vue.axios({
        method: "DELETE",
        url: "/reservas/" + reserva_id,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
      });
      if (response.status == 200) {
        // context.commit('reservas/actDeleteListReservas', reserva_id, { root: true })
      }
      return response;
      // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
    }
  } catch (e) {
  } finally {
    // context.commit('setLoading', false, { root: true })
  }
}

export async function eliminarReservas(context, [access_token, reserva_ids]) {
  try {
    if (access_token) {
      return await Vue.axios({
        method: "DELETE",
        url: "/reservas/eliminar-lote",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        data: {
          reserva_ids,
        },
      });
    }
  } catch (e) {
  }
}

export async function pagoPresupuesto(context, [access_token, reserva_id]) {
  try {
    if (access_token) {
      const response = await Vue.axios({
        method: "GET",
        url: "/pagopresupuesto",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        params: {
          reserva_id,
        },
      });
      if (
        response &&
        response.status == 200 &&
        response.data &&
        response.data.data
      ) {
        context.commit('reservas/actUpdateListReservas', response.data.data, { root: true })
        return response.data.data;
      }

    }
  } catch (e) {
  } finally {
    // context.commit('setLoading', false, { root: true })
  }
}

export function envioCorreos(context, [access_token]) {
  /* if (access_token) {
       Vue.axios({
         method: "GET",
         url: "/envioCorreos",
         headers: {
           "Content-Type": "application/json",
           Accept: "application/json",
           Authorization: "Bearer " + access_token,
         },
       })
       .then(response => {
         if (response && response.status == 200) {
           return 'Correos enviados';
         }
       })
       .catch(e => {
         // maneja el error aquí
       })
       .finally(() => {
         // context.commit('setLoading', false, { root: true })
       });
     }*/
}



export async function confirmarPasajeros(context, [pasajeros, reserva_id]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: "/confirmarPasajeros"  ,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: {
        pasajeros,
        reserva_id,
      },
    });
    if (
      response &&
      response.status == 200 &&
      response.data 
    
    ) {
      return response;
    } else {
      return null;
    }

  } catch (e) {
  } finally {
    context.commit("setLoading", false, { root: true });
  }
}


export async function obtenerUrlPago(context, [reserva_id]) {
  try {
    const response = await Vue.axios({
      method: "GET",
      url: "/obtenerUrlPago?reserva_id=" + reserva_id,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    if (
      response &&
      response.status == 200 &&
      response.data 
    
    ) {
      return response.data;
    } else {
      return null;
    }

  } catch (e) {
  } finally {
   
  }
}

export async function guardarServiciosReserva(context, [access_token, reserva_id, servicios]) {
  try {
    if (access_token) {
      const response = await Vue.axios({
        method: "POST",
        url: "/guardarServiciosReserva",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        data: {
          reserva_id,
          servicios: servicios
        },
      });
      if (response.status === 200) {
        return response.data;
      }
    }
  } catch (e) {
    console.error('Error al guardar servicios:', e);
    throw e;
  }
}

export async function eliminarServicioReserva(context, [access_token, id, reserva_id]) {
  try {
    if (access_token) {
      const response = await Vue.axios({
        method: "POST",
        url: "/eliminarServicioReserva",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        data: {
          id,
          reserva_id,
        },
      });
      if (response.status === 200 && response.data && response.data.reserva) {
        return response.data.reserva;
      }
    }
  } catch (e) {
    console.error('Error al eliminar el servicio:', e);
    throw e;
  }
}


export async function agregarServicioReserva(context, [access_token, reserva_id, servicio_id, titulo, descripcion, importe, etapa_id, tipo_descuento]) {
  try {
    if (access_token) {
      const response = await Vue.axios({
        method: "POST",
        url: "/agregarServicioReserva",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        data: {
          reserva_id,
          servicio_id,
          titulo,
          descripcion,
          importe,
          etapa_id,
          tipo_descuento,
        },
      });
      if (response.status === 200 && response.data && response.data.reserva) {
        return response.data.reserva;
      }
    }
  } catch (e) {
    console.error('Error al agregar el servicio:', e);
    throw e;
  }
}

export async function generarNuevoPresupuesto(context, [access_token, reserva_id]) {
  try {
    const response = await Vue.axios({
      method: "GET",
      url: "/generarPresupuestoPDF/" + reserva_id,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
     
    });
    if (response.status === 200 && response.data?.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al generar el nuevo presupuesto:', e);
    throw e;
  }
}

export async function generarNuevaConfirmacion(context, [access_token, reserva_id]) {
  try {
    const response = await Vue.axios({
      method: "GET",
      url: "/generarConfirmacionPDF/" + reserva_id,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
     
    });
    if (response.status === 200 && response.data?.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al generar la nueva confirmacion:', e);
    throw e;
  }
}

export async function generarBonosAlojamientos(context, [access_token, reserva_id]) {
  try {
    const response = await Vue.axios({
      method: "GET",
      url: "/generarBonosAlojamientosPDF/" + reserva_id,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
     
    });
    if (response.status === 200 && response.data && response.data.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al generar los bonos de alojamientos:', e);
    throw e;
  }
}

export async function generarBonosServicios(context, [access_token, reserva_id]) {
  try {
    const response = await Vue.axios({
      method: "GET",
      url: "/generarBonosServiciosPDF/" + reserva_id,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
     
    });
    if (response.status === 200 && response.data && response.data.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al generar los bonos de servicios:', e);
    throw e;
  }
}

export async function generarBonoServicioIndividual(context, [access_token, reserva_servicio_id]) {
  try {
    const response = await Vue.axios({
      method: "GET",
      url: "/generarBonoServicioPDF/" + reserva_servicio_id,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },

    });
    if (response.status === 200 && response.data?.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al generar el bono individual de servicio:', e);
    throw e;
  }
}

export async function generarBonoAlojamientoIndividual(context, [access_token, reserva_etapa_proveedor_id]) {
  try {
    const response = await Vue.axios({
      method: "GET",
      url: "/generarBonoAlojamientoPDF/" + reserva_etapa_proveedor_id,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },

    });
    if (response.status === 200 && response.data?.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al generar el bono individual de alojamiento:', e);
    throw e;
  }
}

export async function generarProforma(context, [access_token, reserva_id]) {
  try {
    const response = await Vue.axios({
      method: "GET",
      url: "/generarProformaPDF/" + reserva_id,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
     
    });
    if (response.status === 200 && response.data?.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al generar la proforma:', e);
    throw e;
  }
}

export async function generarTarjetas(context, [access_token, reserva_id]) {
  try {
    const response = await Vue.axios({
      method: "GET",
      url: "/generarTarjetasPDF/" + reserva_id,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
     
    });
    if (response.status === 200 && response.data?.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al generar las tarjetas:', e);
    throw e;
  }
}

export async function subirSeguro(context, [access_token, reserva_id, formData]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: '/subirSeguroPDF/' + reserva_id,
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: formData,
    });
    if (response.status === 200 && response.data?.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al subir el seguro:', e);
    throw e;
  }
}

export async function updateNotaExtraEtapa(context, [
  access_token,
  reserva_id,
  reserva_etapa_proveedor_id,
  nota_extra,
  modalidad_pago = null,
  prepago_dias = null,
  prepago_tipo_dias = null,
  prepago_fecha_aviso = null,
]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: "/updateNotaExtraEtapa",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        reserva_id,
        reserva_etapa_proveedor_id,
        nota_extra,
        modalidad_pago,
        prepago_dias,
        prepago_tipo_dias,
        prepago_fecha_aviso,
      },
    });

    if (response.status === 200 && response.data?.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al actualizar la nota extra de la etapa:', e);
    throw e;
  }
}

export async function updateTarifasEtapa(context, [access_token, reserva_id, reserva_etapa_proveedor_id, tarifa_ind, tarifa_doble, tarifa_triple]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: "/updateTarifasEtapa",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        reserva_id,
        reserva_etapa_proveedor_id,
        tarifa_ind,
        tarifa_doble,
        tarifa_triple,
      },
    });

    if (response.status === 200 && response.data?.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al actualizar la tarifa de la etapa:', e);
    throw e;
  }
}

export async function updateEstadoReserva(context, [access_token, reserva_id, estado_id]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: "/cambiar-estado",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        reserva_id,
        estado_id,
      },
    });

    if (response.status === 200 && response.data?.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al actualizar el estado de la reserva:', e);
    throw e;
  }
}

export async function updateEstadoEtapa(context, [access_token, reservaetapa_id, estado_id]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: "/cambiar-estado-etapa",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        reservaetapa_id,
        estado_id,
      },
    });

    if (response.status === 200) {
      if (response.data?.reserva || Object.prototype.hasOwnProperty.call(response.data || {}, "aviso")) {
        return {
          reserva: response.data?.reserva || null,
          aviso: response.data?.aviso || null,
        };
      }

      if (response.data?.id) {
        return {
          reserva: response.data,
          aviso: null,
        };
      }
    }
  } catch (e) {
    console.error('Error al actualizar el estado de la etapa:', e);
    throw e;
  }
}

export async function getTrabajadores(context, [access_token]) {
  try {
    const response = await Vue.axios({
      method: "GET",
      url: "/trabajadores",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
    });
    if (response.status === 200 && response.data) {
      // Si response.data es un objeto con una propiedad que contiene el array
      // (por ejemplo: { data: [...], trabajadores: [...], etc })
      // retornamos el array correcto
      if (Array.isArray(response.data)) {
        return response.data;
      } else if (response.data.data && Array.isArray(response.data.data)) {
        return response.data.data;
      } else if (response.data.trabajadores && Array.isArray(response.data.trabajadores)) {
        return response.data.trabajadores;
      }
      // Si no encontramos un array, retornamos un array vacío
      console.warn('La respuesta de trabajadores no contiene un array válido:', response.data);
      return [];
    }
  } catch (e) {
    console.error('Error al obtener los trabajadores:', e);
    throw e;
  }
}

export async function cambiarTrabajadorAsignado(context, [access_token, reserva_id, asignada_a_id, mensaje]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: "/cambiar-trabajador-asignado",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        reserva_id,
        asignada_a_id,
        mensaje,
      },
    });

    if (response.status === 200 && response.data?.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al cambiar el trabajador asignado:', e);
    throw e;
  }
}

export async function updateProveedorEtapa(context, [access_token, reserva_id, reserva_etapa_proveedor_id, proveedor_id, proveedor_nombre_alias, final_punto_id, enviar_correo_cancelacion = 0]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: "/updateProveedorEtapa",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        reserva_id,
        reserva_etapa_proveedor_id,
        proveedor_id,
        proveedor_nombre_alias,
        final_punto_id,
        enviar_correo_cancelacion,
      },
    });
    if (response.status === 200 && response.data && response.data.reserva) {
      return response.data;
    }
  } catch (e) {
    console.error('Error al actualizar el proveedor de la etapa:', e);
    throw e;
  }
}

export async function getHistorialByReserva(context, [access_token, reserva_id]) {
  try {
    const response = await Vue.axios({
      method: "GET",
      url: "/getHistorialByReserva/" + reserva_id,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
    });
    if (response.status === 200 && response.data && response.data.data) {
      return response.data.data;
    }
  } catch (e) {
    console.error('Error al obtener el historial de la reserva:', e);
    throw e;
  }
}

export async function updateItinerarioAMedida(context, [access_token, reserva_id, itinerario_a_medida]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: "/updateItinerarioAMedida",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        reserva_id,
        itinerario_a_medida,
      },
    });
    if (response.status === 200 && response.data && response.data.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al actualizar el itinerario a medida:', e);
    throw e;
  }
}

export async function eliminarEtapas(context, [access_token, reserva_id, etapas_ids]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: "/eliminarEtapas",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        reserva_id,
        etapas_ids,
      },
    });
    if (response.status === 200 && response.data && response.data.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al eliminar las etapas:', e);
    throw e;
  }
}

export async function enviarCorreo(context, [access_token, reserva_id, de, para, cc, asunto, textoMensaje, adjuntoPresupuesto, adjuntoConfirmacion, 
                                             adjuntoDossier, adjuntoTips, adjuntoBonoAlojamientos, adjuntoBonoServicios, adjuntoProforma, adjuntoSeguro, 
                                             adjuntoSeguroAnulacion, adjuntoAutorizacionTarjeta, adjuntoRegistroViajeros, estado_id, enviarCuestionario]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: "/enviarCorreo",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        reserva_id,
        de,
        para,
        cc,
        asunto,
        textoMensaje,
        adjuntoPresupuesto,
        adjuntoConfirmacion,
        adjuntoDossier,
        adjuntoTips,
        adjuntoBonoAlojamientos,
        adjuntoBonoServicios,
        adjuntoProforma,
        adjuntoSeguro,
        adjuntoSeguroAnulacion,
        adjuntoAutorizacionTarjeta,
        adjuntoRegistroViajeros,
        estado_id,
        enviarCuestionario,
      },
    });
    if (response.status === 200 && response.data?.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al eliminar las etapas:', e);
    throw e;
  }
}

export async function enviarCorreoProveedor(context, [access_token, reserva_id, de, para, cc, asunto, textoMensaje, adjuntoPresupuesto, adjuntoConfirmacion,
                                                      adjuntoDossier, adjuntoTips, adjuntoBonoAlojamientos, adjuntoBonoServicios, adjuntoProforma, adjuntoSeguro,
                                                      adjuntoSeguroAnulacion, adjuntoAutorizacionTarjeta, adjuntoRegistroViajeros, estado_id,
                                                      proveedor_id = null, proveedor_nombre = null]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: "/enviarCorreoProveedor",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        reserva_id,
        de,
        para,
        cc,
        asunto,
        textoMensaje,
        adjuntoPresupuesto,
        adjuntoConfirmacion,
        adjuntoDossier,
        adjuntoTips,
        adjuntoBonoAlojamientos,
        adjuntoBonoServicios,
        adjuntoProforma,
        adjuntoSeguro,
        adjuntoSeguroAnulacion,
        adjuntoAutorizacionTarjeta,
        adjuntoRegistroViajeros,
        estado_id,
        proveedor_id,
        proveedor_nombre,
      },
    });
    if (response.status === 200 && response.data?.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al enviar correo al proveedor:', e);
    throw e;
  }
}

export async function enviarDocumentoACliente(context, [access_token, documento_id, de, para, cc, asunto, textoMensaje]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: "/enviarDocumentoACliente/" + documento_id,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        de,
        para,
        cc,
        asunto,
        textoMensaje,
      },
    });
    if (response.status === 200 && response.data?.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al enviar el documento al cliente:', e);
    throw e;
  }
}

export async function updateServiciosIncCancelados(context, [access_token, reserva_id, servicios_inc_cancelados]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: "/updateServiciosIncCancelados",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        reserva_id,
        servicios_inc_cancelados,
      },
    });
    if (response.status === 200 && response.data && response.data.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al actualizar los servicios inc cancelados:', e);
    throw e;
  }
}

export async function actualizarEtapasPorCambiodeCamino(context, [access_token, reserva_id, camino_id, language]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: "/actualizarEtapasPorCambiodeCamino",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        reserva_id,
        camino_id,
        language,
      },
    });
    if (response.status === 200 && response.data && response.data.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al actualizar las etapas por cambio de camino:', e);
    throw e;
  }
}

export async function agregarNotaInterna(context, [access_token, reserva_id, nota_interna]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: "/agregarNotaInterna",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        reserva_id,
        nota_interna,
      },
    });
    if (response.status === 200 && response.data && response.data.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al agregar la nota interna:', e);
    throw e;
  }
}

export async function crearPasajeros(context, [access_token, pasajero]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: "/pasajeros",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: pasajero,
    });
    if (response.status === 200 && response.data && response.data.data) {
      return response.data.data;
    }
  } catch (e) {
    console.error('Error al actualizar las etapas por cambio de camino:', e);
    throw e;
  }
}


export async function updatePasajero(context, [access_token, pasajero]) {
  try {
      if (access_token) {
        
          const response = await Vue.axios({
              method: 'PUT',
              url: '/pasajeros/' + pasajero.id,
              headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json',
                  'Authorization': 'Bearer ' + access_token,
              },
              data: pasajero
          })
          if (response.status == 200 && response.data && response.data.data) {
            return response.data.data;
          }
        
      }

  } catch (e) {
  } finally {
   // context.commit('setLoading', false, { root: true })
  }
}


export async function eliminarPasajero(context, [access_token, pasajero_id]) {
  try {
      if (access_token) {
          const response = await Vue.axios({
              method: 'DELETE',
              url: '/pasajeros/' + pasajero_id,
              headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json',
                  'Authorization': 'Bearer ' + access_token,
              },
          })

         if (response.status == 200 && response.data && response.data.data) {
          return response.data.data;
         }
      }

  } catch (e) {
  } finally {
    // context.commit('setLoading', false, { root: true })
  }
}

export async function asignarPasajeroHabitacion(context, [access_token, reserva_id, pasajero_id, tipo, numero]) {
  try {
    console.log("Asignando pasajero a habitacion:", {
      reserva_id,
      pasajero_id,
      tipo,
      numero
    });
    const response = await Vue.axios({
      method: "POST",
      url: "/asignarPasajeroHabitacion",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        reserva_id,
        pasajero_id,
        tipo,
        numero,
      },
    });
    if (response.status === 200 && response.data) {
      return response.data.reserva || response.data.data || response.data;
    }
  } catch (e) {
    console.error("Error al asignar pasajero a habitacion:", e);
    throw e;
  }
}

export async function updateClienteEsViajero(context, [access_token, reserva_id, cliente_es_viajero]) {
  try {
    const response = await Vue.axios({
      method: "PUT",
      url: `/reservas/${reserva_id}/cliente-es-viajero`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        cliente_es_viajero,
      },
    });

    if (response.status === 200 && response.data) {
      return response.data.reserva || response.data.data || response.data;
    }
  } catch (e) {
    console.error("Error al actualizar si el cliente es viajero:", e);
    throw e;
  }
}


export async function updateReservaServicioCoste(context, [access_token, reserva_id, servicio_id, coste]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: `/updateReservaServicioCoste`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        reserva_id,
        servicio_id,
        coste,
      },
    });
    if (response.status === 200 && response.data && response.data.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al actualizar el coste del servicio:', e);
    throw e;
  }
}

export async function updateCaminoCorreoIdReserva(context, [access_token, reserva_id, camino_correo_id]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: "/updateCaminoCorreoIdReserva",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        reserva_id,
        camino_correo_id,
      },
    });
    if (response.status === 200 && response.data) {
      return response.data.reserva || response.data.data || response.data;
    }
  } catch (e) {
    console.error("Error al actualizar camino_correo_id de la reserva:", e);
    throw e;
  }
}

export async function updateAlojamientoCorreoInicioIdEtapa(
  context,
  [access_token, reserva_id, reserva_etapa_proveedor_id, alojamiento_correo_inicio_id]
) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: "/updateAlojamientoCorreoInicioIdEtapa",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        reserva_id,
        reserva_etapa_proveedor_id,
        alojamiento_correo_inicio_id,
      },
    });
    if (response.status === 200 && response.data) {
      return response.data.reserva || response.data.data || response.data;
    }
  } catch (e) {
    console.error("Error al actualizar alojamiento_correo_inicio_id:", e);
    throw e;
  }
}

export async function updateAlojamientoCorreoFinIdEtapa(
  context,
  [access_token, reserva_id, reserva_etapa_proveedor_id, alojamiento_correo_fin_id]
) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: "/updateAlojamientoCorreoFinIdEtapa",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        reserva_id,
        reserva_etapa_proveedor_id,
        alojamiento_correo_fin_id,
      },
    });
    if (response.status === 200 && response.data) {
      return response.data.reserva || response.data.data || response.data;
    }
  } catch (e) {
    console.error("Error al actualizar alojamiento_correo_fin_id:", e);
    throw e;
  }
}

export async function updateReservaServicioProveedor(context, [access_token, id, proveedor_id, proveedor_nota]) {
  try {
    console.log("Updating service provider:", {
      access_token,
      id,
      proveedor_id,
    });
    const response = await Vue.axios({
      method: "POST",
      url: `/updateReservaServicioProveedor`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        id,
        proveedor_id,
        proveedor_nota,
      },
    });
    if (response.status === 200 && response.data && response.data.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al actualizar el proveedor del servicio:', e);
    throw e;
  }
}

export async function updateReservaServicioFecha(context, [access_token, id, fecha]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: `/updateReservaServicioFecha`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        id,
        fecha,
      },
    });
    if (response.status === 200 && response.data && response.data.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error("Error al actualizar la fecha del servicio:", e);
    throw e;
  }
}

export async function updateReservaServicioDescripcion(context, [access_token, id, descripcion]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: `/updateReservaServicioDescripcion`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        id,
        descripcion,
      },
    });
    if (response.status === 200 && response.data && response.data.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error("Error al actualizar la descripcion del servicio:", e);
    throw e;
  }
}

export async function solicitarDisponibilidad(context, [access_token, reserva_id, etapa_id, proveedor_id]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: `/solicitarDisponibilidad`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        reserva_id,
        etapa_id,
        proveedor_id,
      },
    });
    if (response.status === 200 && response.data && response.data.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al solicitar disponibilidad:', e);
    throw e;
  }
}

export async function enviarDisponibilidadATodos(context, [access_token, reserva_id, nota_alojamientos = null]) {
  try {
    const response = await Vue.axios({
      method: "POST",
      url: `/enviarDisponibilidadATodos`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
      data: {
        reserva_id,
        nota_alojamientos,
      },
    });
    console.log('response', response);
    if (response.status === 200 && response.data && response.data.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al enviar disponibilidad:', e);
    throw e;
  }
}

export async function eliminarPresupuesto(context, [access_token, presupuesto_id]) {
  try {
    const response = await Vue.axios({
      method: "DELETE",
      url: `/reserva-presupuestos/${presupuesto_id}`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
      },
    });
    console.log('response', response);
    if (response.status === 200 && response.data && response.data.reserva) {
      return response.data.reserva;
    }
  } catch (e) {
    console.error('Error al eliminar presupuesto:', e);
    throw e;
  }
}
